<script setup>
  import { computed } from 'vue';
  import useConfigurationGlobals from '@/composables/useConfigurationGlobals';
  import Icon from '@/components/icons/Icon.vue';

  const { $BRAND } = useConfigurationGlobals();

  const props = defineProps({
    proForecast: {
      type: Object,
      required: true
    },
    midFooter: {
      type: Boolean,
      default: false
    },
    showForecasterBlog: {
      type: Boolean,
      default: true
    }
  });

  const showBaja = computed(() => props.proForecast.forecast_id === 56 && !props.midFooter);

</script>

<template>
  <footer class="jwx-pro-forecast__footer jwx-page__section" data-divider="true">
    <nav class="jwx-pro-forecast__footer-nav">
      <!-- Blog links disabled: blog.weatherflow.com is not currently reachable over HTTPS.
           Restore this block when the blog has a working destination. -->
      <!--
      <ul v-if="showBaja || showForecasterBlog"  class="jwx-block jwx-table-view" data-surface="0">
        <li
          v-if="showBaja"
          class="jwx-table-view__row"
        >
          <a
            class="jwx-table-view__action-row"
            data-type="card"
            href="http://blog.weatherflow.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="jwx-table-view__row-image" data-shape="circle">
              <Icon name="newspaper" />
            </div>
            <p class="jwx-table-view__row-label">
              <span class="jwx-font-size-sm jwx-text-color-subtle jwx-font-weight-400">West Coast Wind Blog:</span><br>
              <span class="jwx-font-weight-500">How to use the Weatherflow sensor network in La Ventana, Baja Sur.</span>
            </p>
          </a>
        </li>
        <li v-if="showForecasterBlog" class="jwx-table-view__row">
          <a
            class="jwx-table-view__action-row"
            data-type="link"
            href="http://blog.weatherflow.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <p class="jwx-table-view__row-label jwx-font-weight-400">Check out the <strong>Forecaster Blog</strong> for more insights from our forecast team. </p>
            <div class="jwx-table-view__action-row-symbol">
              <Icon name="chevron-right" />
            </div>
          </a>
        </li>
      </ul>
      -->
      <ul v-if="props.midFooter" class="jwx-block jwx-table-view" data-surface="0">
        <li
          v-if="showBaja"
          class="jwx-table-view__row"
        >
          <a
            class="jwx-table-view__action-row"
            data-type="card"
            href="https://www.iwindsurf.com/travel.iws?genID=22"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="jwx-table-view__row-icon">
              <Icon name="book-open" />
            </div>
            <p class="jwx-table-view__row-label">Complete Baja Guide</p>
            <div class="jwx-table-view__action-row-symbol">
              <Icon name="chevron-right" />
            </div>
          </a>
        </li>
        <li class="jwx-table-view__row">
          <a
            class="jwx-table-view__action-row"
            data-type="link"
            href="https://weatherflow.com/fx-feedback/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="jwx-table-view__row-icon">
              <Icon name="chat" />
            </div>
            <p class="jwx-table-view__row-label">Provide Forecast Feedback</p>
            <div class="jwx-table-view__action-row-symbol">
              <Icon name="chevron-right" />
            </div>
          </a>
        </li>        
      </ul>
    </nav>
  </footer>
</template>